export default __webpack_public_path__ + "static/media/11_2.e5dabd38.jpg";